import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { deepMix } from '@antv/util';
import { Container } from '../utils/container';
import { calcBBox } from '../utils/vector';
import { indexOf } from '../utils/array';
import { createInnerGuide, inferColor, setAnimation, setStyle, toCell } from './facetRect';
import { useDefaultAdaptor, useOverrideAdaptor } from './utils';
var setScale = useDefaultAdaptor(function (options) {
  return {
    scale: {
      x: {
        guide: null,
        paddingOuter: 0,
        paddingInner: 0.1
      },
      y: {
        guide: null,
        range: [0, 1],
        paddingOuter: 0,
        paddingInner: 0.1
      }
    }
  };
});
var setChildren = useOverrideAdaptor(function (options) {
  var data = options.data,
    children = options.children,
    _options$x = options.x,
    originX = _options$x === void 0 ? 0 : _options$x,
    _options$y = options.y,
    originY = _options$y === void 0 ? 0 : _options$y,
    viewKey = options.key;
  var createChildren = function createChildren(visualData, scale, layout) {
    var scaleX = scale.x,
      scaleY = scale.y;
    var paddingLeft = layout.paddingLeft,
      paddingTop = layout.paddingTop,
      marginLeft = layout.marginLeft,
      marginTop = layout.marginTop;
    var _scaleX$getOptions = scaleX.getOptions(),
      domainX = _scaleX$getOptions.domain;
    var _scaleY$getOptions = scaleY.getOptions(),
      domainY = _scaleY$getOptions.domain;
    var index = indexOf(visualData);
    var bboxs = visualData.map(function (_ref) {
      var points = _ref.points;
      return calcBBox(points);
    });
    var values = visualData.map(function (_ref2) {
      var x = _ref2.x,
        y = _ref2.y;
      return [scaleX.invert(x), scaleY.invert(y)];
    });
    var facets = values.map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        fx = _ref4[0],
        fy = _ref4[1];
      return {
        columnField: fx,
        columnIndex: domainX.indexOf(fx),
        columnValue: fx,
        columnValuesLength: domainX.length,
        rowField: fy,
        rowIndex: domainY.indexOf(fy),
        rowValue: fy,
        rowValuesLength: domainY.length
      };
    });
    var normalizedChildren = facets.map(function (facet) {
      if (Array.isArray(children)) return children;
      return [children(facet)].flat(1);
    });
    return index.flatMap(function (i) {
      var _bboxs$i = _slicedToArray(bboxs[i], 4),
        left = _bboxs$i[0],
        top = _bboxs$i[1],
        width = _bboxs$i[2],
        height = _bboxs$i[3];
      var _values$i = _slicedToArray(values[i], 2),
        fx = _values$i[0],
        fy = _values$i[1];
      var facet = facets[i];
      var children = normalizedChildren[i];
      return children.map(function (d) {
        var _a, _b;
        var scale = d.scale,
          key = d.key,
          encode = d.encode,
          axis = d.axis,
          rest = __rest(d, ["scale", "key", "encode", "axis"]);
        var guideY = (_a = scale === null || scale === void 0 ? void 0 : scale.y) === null || _a === void 0 ? void 0 : _a.guide;
        var guideX = (_b = scale === null || scale === void 0 ? void 0 : scale.x) === null || _b === void 0 ? void 0 : _b.guide;
        var defaultScale = {
          // Do not sync position scales among facets by default.
          x: {
            facet: false
          },
          // Do not sync position scales among facets by default.
          y: {
            facet: false
          }
        };
        var newAxis = {
          x: createGuideX(guideX)(facet, data),
          y: createGuideY(guideY)(facet, data)
        };
        var defaultAxis = {
          x: {
            tickCount: 5
          },
          y: {
            tickCount: 5
          }
        };
        return Object.assign({
          data: data,
          parentKey: viewKey,
          key: "".concat(key, "-").concat(i),
          x: left + paddingLeft + originX + marginLeft,
          y: top + paddingTop + originY + marginTop,
          width: width,
          height: height,
          margin: 0,
          paddingLeft: 0,
          paddingRight: 0,
          paddingTop: 0,
          paddingBottom: 0,
          frame: true,
          scale: deepMix(defaultScale, scale),
          axis: deepMix(defaultAxis, axis, newAxis),
          // Hide all legends for child mark by default,
          // they are displayed in the top-level.
          legend: false,
          encode: deepMix({}, encode, {
            x: fx,
            y: fy
          })
        }, rest);
      });
    });
  };
  return {
    children: createChildren
  };
});
/**
 * @todo Use transform instead of override data directly.
 */
var setData = useOverrideAdaptor(function (options) {
  var encode = options.encode,
    rest = __rest(options, ["encode"]);
  var _encode$position = encode.position,
    P = _encode$position === void 0 ? [] : _encode$position,
    _encode$x = encode.x,
    X = _encode$x === void 0 ? P : _encode$x,
    _encode$y = encode.y,
    Y = _encode$y === void 0 ? _toConsumableArray(P).reverse() : _encode$y,
    restEncode = __rest(encode, ["position", "x", "y"]);
  var data = [];
  var _iterator = _createForOfIteratorHelper([X].flat(1)),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var $x = _step.value;
      var _iterator2 = _createForOfIteratorHelper([Y].flat(1)),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var $y = _step2.value;
          data.push({
            $x: $x,
            $y: $y
          });
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return Object.assign(Object.assign({}, rest), {
    data: data,
    encode: Object.assign(Object.assign({}, restEncode), {
      x: '$x',
      y: '$y'
    }),
    scale: Object.assign(Object.assign({}, [X].flat(1).length === 1 && {
      x: {
        paddingInner: 0
      }
    }), [Y].flat(1).length === 1 && {
      y: {
        paddingInner: 0
      }
    })
  });
});
function createGuideX(guideX) {
  if (typeof guideX === 'function') return guideX;
  if (guideX === null) return function () {
    return null;
  };
  return function (facet, data) {
    var rowIndex = facet.rowIndex,
      rowValuesLength = facet.rowValuesLength; // Only the bottom-most facet show axisX.
    if (rowIndex !== rowValuesLength - 1) return createInnerGuide(guideX, data);
  };
}
function createGuideY(guideY) {
  if (typeof guideY === 'function') return guideY;
  if (guideY === null) return function () {
    return null;
  };
  return function (facet, data) {
    var columnIndex = facet.columnIndex; // Only the left-most facet show axisY.
    if (columnIndex !== 0) return createInnerGuide(guideY, data);
  };
}
/**
 * @todo Layout mode: layer, row, col...
 * @todo Specify show axis or not.
 */
export var RepeatMatrix = function RepeatMatrix() {
  return function (options) {
    var newOptions = Container.of(options).call(toCell).call(inferColor).call(setChildren).call(setData).call(setAnimation).call(setStyle).call(setScale).value();
    return [newOptions];
  };
};